import { takeEvery, call, put } from "redux-saga/effects";
import { getLanguages, setLanguages } from "../constants";
import { getAllLanguagesData } from "../api/languages.api";

function* handleGetLanguages() {
  try {
    const result: { id: number; name: string; status?: boolean }[] = yield call(
      getAllLanguagesData
    );
    yield put({ type: setLanguages, languages: result });
  } catch (error) {
    console.log("Error: ", error);
  }
}

export default function* getAllLanguages() {
  yield takeEvery(getLanguages, handleGetLanguages);
}
